<div class="heatmap-wrapper">
  <div id="map_leaflet" class="map_leaflet" style="width: 100%; height: 100%;"></div>
  <div class="timeline-wrapper"><button>play</button>

  </div>
</div>

